import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import CertificationSessionAchievedFieldContainer from "module/certificationSession/enrichedComponent/achievedField/CertificationSessionAchievedFieldContainer";
import CertificationSessionRemarksFieldContainer from "module/certificationSession/enrichedComponent/remarksField/CertificationSessionRemarksFieldContainer";
import NestedElement from "component/nestedElement/NestedElement";

interface Props {
  name: string;
  level: number;
}

const CertificationSessionTableRowItem: React.FC<Props> = ({ name, level }) => {
  return (
    <TableRow hover>
      <TableCell align="left">
        <Typography variant="body2" gutterBottom>
          <NestedElement {...{ level }}>{name}</NestedElement>
        </Typography>
      </TableCell>
      <TableCell align="left">
        <CertificationSessionAchievedFieldContainer />
      </TableCell>
      <TableCell>
        <CertificationSessionRemarksFieldContainer />
      </TableCell>
    </TableRow>
  );
};

export default React.memo(CertificationSessionTableRowItem);
